import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import { dataHooks } from './constants';

var handleChange = function handleChange(_ref) {
  var value = _ref.value,
      onCheck = _ref.onCheck,
      onChange = _ref.onChange,
      disabled = _ref.disabled;

  if (disabled) {
    return;
  }

  if (!value && onCheck) {
    onCheck();
  }

  onChange(!value);
};

var Toggle = function Toggle(_ref2) {
  var getClassName = _ref2.getClassName,
      disabled = _ref2.disabled,
      automationId = _ref2.automationId,
      dataHook = _ref2.dataHook,
      name = _ref2.name,
      innerInputClass = _ref2.innerInputClass,
      value = _ref2.value,
      indeterminate = _ref2.indeterminate,
      children = _ref2.children,
      onCheck = _ref2.onCheck,
      _onChange = _ref2.onChange,
      onMouseLeave = _ref2.onMouseLeave,
      onMouseEnter = _ref2.onMouseEnter;
  return /*#__PURE__*/React.createElement("label", {
    className: getClassName('control-boolean') + (disabled ? ' disabled' : ''),
    "data-aid": automationId,
    "data-hook": dataHook,
    onMouseLeave: onMouseLeave,
    onMouseEnter: onMouseEnter
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    "data-hook": dataHooks.toggleInputTag,
    className: getClassName('input input-' + name, innerInputClass || ''),
    checked: value,
    disabled: disabled,
    "data-indeterminate": indeterminate,
    onChange: function onChange() {
      return handleChange({
        value: value,
        onCheck: onCheck,
        onChange: _onChange,
        disabled: disabled
      });
    }
  }), children);
};

Toggle.displayName = displayNames.TOGGLE;
Toggle.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  onCheck: PropTypes.func,

  /** A callback function to be called on mouseEnter event */
  onMouseEnter: PropTypes.func,

  /** A callback function to be called on mouseLeave event */
  onMouseLeave: PropTypes.func
};
Toggle.defaultProps = {
  disabled: false,
  indeterminate: false
};
export default compose(Toggle);